import { color } from '@mui/system'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import InformacionGeneralFormComponent from '../Forms/InformacionGeneralFormComponent'
import ValidarDomicilioFormComponent from '../Forms/ValidarDomicilioFormComponent'
import CuestionarioEnvasadoForm from '../Forms/CuestionarioEnvasadoFormComponent'
import TabsanexoComponent from './TabsanexoComponent'
import TabsEquiposComponent from './TabsEquiposComponent'
import estilos from './TabsInspeccionarComponent.module.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { obtenerSolicitudDetalleFC_01, obtenerSolicitudDetalleFC_01ConMaps } from '../../../../redux/DucksAtencionACliente/FC_01AtencionAClienteDucks';
import FotoGaleriaComponent from '../Forms/Fotogaleria/FotoGaleriaComponent'
import TabsRecepcionMateriaPrimaComponent from './TabsRecepcionMateriaPrimaComponent'
import BuenasPracticasComponent from '../Forms/BuenasPracticasComponent'
import FotoGaleriaEnvasadoComponent from '../Forms/Fotogaleria/FotoGaleriaEnvasadoComponent'
import FotoGaleriaAlmacenComponent from '../Forms/Fotogaleria/FotoGaleriaAlmacenComponent'

function TabsInspeccionar(props) {


    const [tabUno, setTabUno] = React.useState(true)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(false)
    const [tabCuatro, setTabCuatro] = React.useState(false)
    const [tabCinco, setTabCinco] = React.useState(false)
    const [tabSeis, setTabSeis] = React.useState(false)

    const todo = props.detalles;
    const instalacion = props.instalacion;
    const idinforme = props.idinforme;
    const dataUser = props.inspectorLogeado;
    const verdaderaInstalacion = props.verdaderaInstalacion;
    const ncomision = props.ncomision;
    const folioui = props.folioui;
    const solicitud = props.solicitud;

    const fc01ConMap = useSelector(store => store.ModuloConsulta.fc01ConMap)

    const dispatch = useDispatch()

    const irASeccion = () => {
        const element = document.getElementById('inicioTabs');

        if (element) {
            // 👇 Will scroll smoothly to the top of the next section
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };


    const setearValoresUno = () => {
        irASeccion()
        setTabUno(true); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabSeis(false);
    }
    const setearValoresDos = () => {
        irASeccion()
        setTabUno(false); setTabDos(true); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabSeis(false);
    }
    const setearValoresTres = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(true); setTabCuatro(false); setTabCinco(false); setTabSeis(false);
    }
    const setearValoresCuatro = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(true); setTabCinco(false); setTabSeis(false);
    }
    const setearValoresCinco = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(true); setTabSeis(false);
    }
    const setearValoresSeis = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabSeis(true);
    }

    React.useEffect(() => {
        if (todo.idcliente != undefined) {
            dispatch(obtenerSolicitudDetalleFC_01ConMaps(solicitud.fc_01_solicitudderegistro.idfc01_solicitudregistro))
            dispatch(obtenerSolicitudDetalleFC_01(solicitud.fc_01_solicitudderegistro.idfc01_solicitudregistro))
        }
    }, [todo])

    React.useEffect(() => {
        let rowsAnexos = []
        let rowDocumentacion = []

        for (const datos in todo.anexocliente) {
            rowDocumentacion.push({ id: '', nameDoc: (todo.anexocliente[datos].tipoanexo.descripcion + ', alias: ' + todo.anexocliente[datos].informaciongeneralinstalacioncliente.alias).toUpperCase() })

            let filtro = fc01ConMap?.anexo?.filter(anexo => anexo?.informaciongeneral?.instalacionnumero === todo?.anexocliente[datos]?.informaciongeneralinstalacioncliente?.instalacionnumero &&
                anexo.informaciongeneral?.alias === todo?.anexocliente[datos]?.informaciongeneralinstalacioncliente?.alias)
            rowsAnexos.push({ id: '', valor: (todo.anexocliente[datos].tipoanexo.descripcion + ', alias: ' + todo.anexocliente[datos].informaciongeneralinstalacioncliente.alias).toUpperCase() })
            rowsAnexos.push({
                id: '', campo: 'Domicilio de instalación',
                valor: todo.anexocliente[datos].informaciongeneralinstalacioncliente.calle + ',' + todo.anexocliente[datos].informaciongeneralinstalacioncliente.numerointerior + ',' +
                    todo.anexocliente[datos].informaciongeneralinstalacioncliente.numeroexterior + ',' + todo.anexocliente[datos].informaciongeneralinstalacioncliente.colonia + ',' +
                    todo.anexocliente[datos].informaciongeneralinstalacioncliente.codigopostal + ',' + todo.anexocliente[datos].informaciongeneralinstalacioncliente.localidad + ',' +
                    todo.anexocliente[datos].informaciongeneralinstalacioncliente.municipio + ',' + todo.anexocliente[datos].informaciongeneralinstalacioncliente.estado,
                observacion: filtro?.[0]?.informaciongeneral?.informaciongeneralmap?.[0]?.domicilio
            })
            for (const i in todo.anexocliente[datos].archivosinstalacionescliente) {
                const nameId = todo.anexocliente[datos].archivosinstalacionescliente[i].nameid
                let nameDoc = ''
                if ((nameId).includes('TITULOINS')) nameDoc = 'Copia del título de propiedad a nombre del solicitante'
                else if ((nameId).includes('CAINS')) nameDoc = 'Contrato de arrendamiento'
                else if ((nameId).includes('IOVRINS')) nameDoc = 'Identificación oficial vigente Arrendador'
                else if ((nameId).includes('IOVOINS')) nameDoc = 'Identificación oficial vigente Arrendatario'
                else if ((nameId).includes('CCINS')) nameDoc = 'Contrato comodato'
                else if ((nameId).includes('IOVEINS')) nameDoc = 'Identificación oficial vigente del comodante'
                let unidad = ''
                if (todo.anexocliente[datos].tipoanexo.descripcion == 'Unidad de produccion') unidad = 'Unidad de producción'
                if (todo.anexocliente[datos].tipoanexo.descripcion == 'Unidad de envasado') unidad = 'Unidad de envasado'
                if (todo.anexocliente[datos].tipoanexo.descripcion == 'Unidad de almacen') unidad = 'Unidad de almacén'
                rowDocumentacion.push({
                    id: '',
                    observacion: todo?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.observaciones,
                    fechaInicio: todo?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.fechainicio !== null ? todo?.archivosinstalacionescliente?.[datos]?.archivosinstalacionescliente?.[i]?.fechainicio : '',
                    fechaTermino: todo?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.fechafin !== null ? todo?.archivosinstalacionescliente?.[datos]?.archivosinstalacionescliente?.[i]?.fechafin : '',
                    estatus: todo?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.estatus !== null ? todo?.archivosinstalacionescliente?.[datos]?.archivosinstalacionescliente?.[i]?.estatus : 'Agregar',
                    tabla: 'archivosinstalacionescliente',
                    nombreId: 'idanexocliente',
                    idSolicitud: todo?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.idanexocliente,
                    nameid: nameId, nameDoc: nameDoc + ' de la instalación ' + unidad + ': ' + todo.anexocliente[datos].informaciongeneralinstalacioncliente.alias,
                    idAnexo: todo?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.idarchivosinstalacion
                })
            }
            for (const i in todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente) {
                rowsAnexos.push({
                    id: '', campo: 'Nombre del responsable', valor: todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].nombreresponsable,
                    observacion: filtro?.[0]?.informaciongeneral?.responsablesdeinstalacion?.[0]?.responsablesdeinstalacionmap?.[i]?.nombreresponsable
                })
                rowDocumentacion.push({
                    id: '',
                    observacion: todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.observaciones,
                    fechaInicio: todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.fechainicio !== null ? todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.fechainicio : '',
                    fechaTermino: todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.fechafin !== null ? todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.fechafin : '',
                    estatus: todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.estatus !== null ? todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.estatus : 'Agregar',
                    tabla: 'archivosresposansablescliente',
                    nombreId: 'idarchivosresponsables',
                    idSolicitud: todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.idresponsabledeinstalacioncliente,
                    nameid: todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.nameid,
                    nameDoc: 'Identificación oficial vigente del responsable: ' + todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].nombreresponsable,
                    idAnexo: todo.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.idarchivosresponsables
                })
            }
        }
    }, [todo, fc01ConMap])

    return (
        <Fragment><br />
            <div className={`row text-center ${estilos.tabsSegundoNivel} mt-2`}>
                {/**OPCIONES NIVEL 2 */}
                <div className='row mt-2'>
                    <div className='col-3' >
                        <button onClick={() => setearValoresUno()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabUno ? '#68813B' : 'transparent', color: tabUno ? 'white' : 'black' }}>Información <br />General</button>
                    </div>
                    <div className='col-2'>
                        <button onClick={() => setearValoresDos()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabDos ? '#68813B' : 'transparent', color: tabDos ? 'white' : 'black' }}>Validación de <br />domicilio</button>

                    </div>
                    {
                        //verdaderaInstalacion.idtipoanexo === 2 ?
                        //    <div className='col-2'>
                        //        <button onClick={() => setearValoresSeis()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabSeis ? '#68813B' : 'transparent', color: tabSeis ? 'white' : 'black' }}>Cumplimiento con NOM 070</button>
                        //
                        //    </div>
                        //    : <div />
                    }
                    <div className='col-2'>
                        <button onClick={() => setearValoresTres()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabTres ? '#68813B' : 'transparent', color: tabTres ? 'white' : 'black' }}>Procesos <br />y Equipo</button>

                    </div>
                    <div className='col-2'>
                        <button onClick={() => setearValoresCuatro()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabCuatro ? '#68813B' : 'transparent', color: tabCuatro ? 'white' : 'black' }}>Foto<br></br>galería<br /></button>

                    </div>
                    <div className='col-3'>
                        <button onClick={() => setearValoresCinco()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabCinco ? '#68813B' : 'transparent', color: tabCinco ? 'white' : 'black' }}>Evaluación de <br></br>B.P.M</button>
                    </div>
                </div>


                {
                    tabUno ? (
                        <div className='row text-center'>
                            {fc01ConMap &&
                                <InformacionGeneralFormComponent detalles={todo} instalacion={instalacion} inspectorLogeado={dataUser} fc01={fc01ConMap} idinforme={idinforme} verdaderaInstalacion={verdaderaInstalacion} ncomision={ncomision} folioui={folioui}></InformacionGeneralFormComponent>
                            }
                            <div className="col mt-5 mb-3">
                            </div>
                            <div className="col mt-5 mb-3">
                                <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresDos()}>Ir a Validar domicilio<ArrowForwardIcon /></button>
                            </div>
                        </div>

                    ) :
                        tabDos ? (
                            <div className='row text-center'>
                                <ValidarDomicilioFormComponent detalles={todo} instalacion={instalacion} idinforme={idinforme} verdaderaInstalacion={verdaderaInstalacion}></ValidarDomicilioFormComponent>
                                <div className="col">
                                    <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresUno()}><ArrowBackIcon />Ir a Información General</button>
                                </div>
                                <div className="col">
                                    <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresTres()}>Ir a Procesos y Equipo<ArrowForwardIcon /></button>
                                </div>
                            </div>

                        ) :
                            tabTres ? (
                                <div className='row text-center'>
                                    <TabsRecepcionMateriaPrimaComponent detalles={todo} instalacion={instalacion} idinforme={idinforme} verdaderaInstalacion={verdaderaInstalacion}></TabsRecepcionMateriaPrimaComponent>
                                    <div className="col mt-5 mb-3">
                                        <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresDos()}><ArrowBackIcon />Ir a Validar domicilio</button>
                                    </div>
                                    <div className="col mt-5 mb-3">
                                        <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresCuatro()}>Ir a Fotogaleria<ArrowForwardIcon /></button>
                                    </div>
                                </div>
                            ) :
                                tabCuatro ? (
                                    <div className='row text-center'>
                                        {
                                            verdaderaInstalacion.idtipoanexo === 2 ?
                                                <FotoGaleriaEnvasadoComponent idinforme={idinforme}></FotoGaleriaEnvasadoComponent>
                                                :
                                                verdaderaInstalacion.idtipoanexo === 3 ?
                                                    <FotoGaleriaAlmacenComponent idinforme={idinforme}></FotoGaleriaAlmacenComponent>
                                                    :
                                                    <FotoGaleriaComponent idinforme={idinforme}></FotoGaleriaComponent>

                                        }

                                        <div className="col mt-5 mb-3">
                                            <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresTres()}><ArrowBackIcon />Ir a Procesos y Equipo</button>
                                        </div>
                                        <div className="col mt-5 mb-3">
                                            <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresCinco()}>Ir a Evaluación de Buenas Practicas de Manofactura<ArrowForwardIcon /></button>
                                        </div>
                                    </div>
                                ) :
                                    tabCinco ? (
                                        <div className='row text-center'>
                                            <BuenasPracticasComponent detalles={todo} instalacion={instalacion} idinforme={idinforme} verdaderaInstalacion={verdaderaInstalacion} solicitud={solicitud}></BuenasPracticasComponent>
                                            <div className="col mt-5 mb-3">
                                                <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresCuatro()}><ArrowBackIcon />Ir a Fotogalería</button>
                                            </div>
                                            <div className="col mt-5 mb-3">
                                            </div>
                                            <div className="col mt-5 mb-3">
                                            </div>
                                        </div>

                                    ) :
                                        tabSeis ? (
                                            <div className='row text-center'>
                                                <CuestionarioEnvasadoForm detalles={todo} instalacion={instalacion} idinforme={idinforme}></CuestionarioEnvasadoForm>
                                                <div className="col mt-5 mb-3">
                                                    <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresCinco()}><ArrowBackIcon />Ir a Fotogalería</button>
                                                </div>
                                                <div className="col mt-5 mb-3">
                                                </div>
                                                <div className="col mt-5 mb-3">
                                                </div>
                                            </div>

                                        ) :
                                            <div />

                }

            </div>

        </Fragment>
    );
};


export default withRouter(TabsInspeccionar)